import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n";
import { initSecurityProtections } from "./lib/security";
import { checkCompatibility, renderIncompatibleFallback } from "./lib/compatibility";
import { warmGoogleMapsKey } from "./lib/googleMapsLoader";
import { preloadPaymentAssets } from "./lib/paymentAssets";
import { lockDocumentTitle } from "./lib/lockDocumentTitle";

// HashRouter only reads location.hash. Convert clean deep links (e.g. shared
// /imovel/:id?ref=host) into /#/imovel/:id?ref=host so they open the right page.
if (typeof window !== "undefined") {
  const { pathname, search, hash } = window.location;
  if (pathname && pathname !== "/" && pathname !== "/index.html" && (!hash || hash === "#")) {
    window.history.replaceState(null, "", `/#${pathname}${search}`);
  }
}

// Lock the browser tab title to a generic value before any other code runs,
// so internal module names never leak through document.title.
lockDocumentTitle();

initSecurityProtections();

// Pré-aquece o Google Maps (chave + script) o mais cedo possível para que
// qualquer ecrã com mapa apareça já desenhado, sem placeholder visível.
warmGoogleMapsKey();

// Pré-carrega ícones e logo do modal de pagamento (decode em background)
// para que o modal abra sem flash branco em web, PWA e Capacitor.
if (typeof window !== "undefined") {
  const run = () => preloadPaymentAssets();
  if ("requestIdleCallback" in window) {
    (window as any).requestIdleCallback(run, { timeout: 1500 });
  } else {
    setTimeout(run, 80);
  }
}


// Compatibility gate — only blocks ancient devices/browsers.
// On native Capacitor we never block (the WebView ships with the app).
const isCapacitorNative =
  typeof (window as any).Capacitor !== "undefined" &&
  (window as any).Capacitor.isNativePlatform?.() === true;

if (!isCapacitorNative) {
  const compat = checkCompatibility();
  if (!compat.compatible) {
    renderIncompatibleFallback(compat);
    throw new Error("[BeraStays] incompatible browser — fallback rendered");
  }
} else {
  // Mobile App Native Optimization (Capacitor)
  import("@capacitor/core").then(({ Capacitor }) => {
    // 1. Force Portrait Orientation
    import("@capacitor/screen-orientation")
      .then(({ ScreenOrientation }) => {
        ScreenOrientation.lock({ orientation: 'portrait' }).catch(console.warn);
      })
      .catch(() => {});
      
    // 2. Enable Privacy Screen (Blocks Screenshots on sensitive screens)
    import("@capacitor-community/privacy-screen")
      .then(({ PrivacyScreen }) => {
        PrivacyScreen.enable().catch(console.warn);
      })
      .catch(() => {});
  }).catch(() => {});
}

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
